"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _breakLines = require("../../../utils/breakLines");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const VenuePage = props => {
  let {
    t,
    title,
    header,
    parkingDetails
  } = props;
  title = title || t("Pages.Venue.Title");
  header = header || t("Pages.Venue.Header");
  parkingDetails = parkingDetails || t("Pages.Venue.Description.ParkingDetails");
  const ua = navigator.userAgent.toLowerCase();
  const query = encodeURIComponent(t("Pages.Venue.Description.Query"));
  let url;
  if (/iphone|ipad|ipod/.test(ua)) {
    url = "http://maps.apple.com/?q=".concat(query);
  } else if (/android/.test(ua)) {
    url = "geo:0,0?q=".concat(query);
  } else {
    url = "https://www.google.com/maps/search/?api=1&query=".concat(query);
  }
  (0, _react.useEffect)(() => {
    document.title = title;
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "con-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-content con-title-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-flex__container"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "con-heading con-heading__h3"
  }, header), /*#__PURE__*/_react.default.createElement("p", {
    className: "con-text con-text__Xtra-larger-regular"
  }, t("Pages.Venue.Description.VenueDescription")), /*#__PURE__*/_react.default.createElement("a", {
    href: url,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "con-text con-text__Xtra-larger-regular con-text__Xtra-larger-regular--underline venue-links link-styles__1"
  }, t("Pages.Venue.Description.Location"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "con-flex__image"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "con-venue-image",
    src: t("Pages.Venue.Description.ImageUrl"),
    alt: t("Pages.Venue.Description.ImageAlt")
  }))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("iframe", {
    frameBorder: "0",
    "data-testid": "venue-map",
    src: t("Pages.Venue.Description.LocationUrl"),
    allow: "autoplay, fullscreen, picture-in-picture",
    allowFullScreen: true,
    className: "map"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "con-flex con-flex__column"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-flex con-flex__park"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "con-text__Xtra-larger-regular con-text__Xtra-larger-SemiBold con-text__Xtra-larger-SemiBold--bold"
  }, t("Pages.Venue.Description.Parking")), (0, _breakLines.breakLines)(parkingDetails, "con-text__large-regular con-text__large-regular")), /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("a", {
    href: t("Pages.Venue.Description.FacilitiesUrl"),
    target: "_blank",
    rel: "noreferrer",
    className: "con-text__Xtra-larger-regular con-text__Xtra-larger-regular--underline link-styles__1"
  }, t("Pages.Venue.Description.Facilities"))))));
};
VenuePage.propTypes = {
  t: _propTypes.default.func,
  title: _propTypes.default.string,
  header: _propTypes.default.string,
  parkingDetails: _propTypes.default.string
};
var _default = exports.default = VenuePage;